import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-config-mdm>
  <paedml-modal prefix={opts.prefix} 
      heading={heading} opname={opts.opname} edit={opts.edit} 
      selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
      submitfunc={submitHandler}>
  
    <yield to="fields">

      <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
        <p class="my-auto">Der Status des MDM-Servers wird aktualisiert...</p>
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>

      <div if={!parent.loading}>
       
        <div class="row" if={!parent.data.settingsOk}>
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-danger">
              <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                  <strong class="text-danger pl-1 pt-2">Die MDM Umgebung ist nicht vollständig konfiguriert und kann nicht aktualisiert werden. Bitte setzen Sie die erforderlichen Werte in den MDM-Grundeinstellungen.</strong>
              </span>
              </div>
          </div>
        </div>

        <div class="paedml-input-group" if={!parent.data.databaseOk || !parent.data.storageOk}>
          <div class="row">
           <div class="col-md-6">
            <paedml-form-input name="database" label="MDM Datenbank" 
              readonly value={parent.data.database}
              />
            </div>
            <div class="col-md-6">
              <paedml-form-input name="requiredDatabase" label="MDM Datenbank - Erforderlich" 
                readonly value={parent.data.requiredDatabase}
                />
            </div>
            <div class="col-md-6">
              <paedml-form-input name="storage" label="MDM Speicher" 
                readonly value={parent.data.storage}
                />
            </div>
            <div class="col-md-6">
              <paedml-form-input name="requiredStorage" label="MDM Speicher - Erforderlich" 
                readonly value={parent.data.requiredStorage}
                />
            </div>
            <div class="col-md-12">
              <div class="mt-2 p-2 border border-danger">
                <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                    <strong class="text-danger pl-1 pt-2">Die Datenbank und der Speicher müssen aktualisiert werden. Bitte lesen Sie die Migrationsanleitung.</strong>
                </span>
                </div>
            </div>
          </div>
        </div>

        <div if={parent.data.databaseOk && parent.data.storageOk && parent.data.settingsOk}>

          <div class="paedml-input-group">
            <div class="pb-1">
            ➊ MDM Server starten
            </div>
            <div class="row">
            <div class="col-md-9" if={parent.data.status == 0}>
              <label>Der MDM-Server ist inaktiv. Klicken Sie auf 'Initialisieren' um den MDM-Server zu starten.</label>
              </div>
              <div class="col-md-9" if={parent.data.status == 1}>
              <label>Der MDM-Server wurde in einer älteren Version installiert. Klicken Sie auf 'Initialisieren' um den Server zu aktualisieren.</label>
              </div>
              <div class="col-md-12" if={parent.data.status == 2}>
                <label>Der MDM-Server wird gestartet. Bitte warten Sie, bis der Server vollständig gestartet ist.</label>
              </div>
                
              <div class="col-md-3" if={parent.data.status == 0 || parent.data.status == 1}>
                  <button class="btn btn-primary" onclick="{parent.init}">Initialisieren</button>
              </div>
                
              <div class="col-md-12" if={parent.data.status == 3 || parent.data.status == 4 || parent.data.status == 5}>
                <div class="p-2 border border-success">
                    <span><paedml-icon icon="fas-check-circle" simple="success" />
                        <strong class="text-success pl-1 pt-2">Der MDM-Server wurde gestartet.</strong>
                    </span>
                </div>
              </div>
            </div>
          </div>

          <div class="paedml-input-group">
            <div class="pb-1">
            ➋ Lizenz
            </div>
            <div class="row">
              <div class="col-md-12" if={parent.data.isValidLicence}>
                <div class="p-2 border border-success">
                  <span><paedml-icon icon="fas-check-circle" simple="success" />
                    <strong class="text-success pl-1 pt-2">Education Lizenz vorhanden</strong>
                  </span>
                </div>
              </div>
              <div class="col-md-12" if={!parent.data.isValidLicence}>
                <label>Um die Konfiguration des MDM-Servers (Schritt 3) durchführen zu können, benötigen Sie die <strong>EDUCATION</strong>-Lizenz von Relution.</label>
                <label>Kontaktieren Sie hierzu bitte Relution unter Angabe des entsprechenden FQDN.</label>
              </div>
              <div class="col-md-12" if={parent.data.status == 3 && !parent.data.isValidLicence}>
                <label>Die <strong>EDUCATION</strong>-Lizenz ist noch nicht aktiviert. Bitte klicken Sie auf 'Status aktualisieren' um die aktuelle Lizenz abzufragen.</label>
              </div>
            </div>
          </div>
        
          <div class="paedml-input-group">
            <div class="pb-1">
            ➌ MDM-Server konfigurieren
            </div>
            <div class="row">
              <div class="col-md-12" if={parent.data.status == 0 || parent.data.status == 1 || parent.data.status == 2}>
                  <label>Die MDM-Server Konfiguration kann nur erfolgen, nachdem der MDM-Server gestartet ist.</label>
              </div>
              <div class="col-md-12" if={parent.data.status == 3 && !parent.data.isValidLicence}> 
                  <label>Die MDM-Server Konfiguration kann nur erfolgen, nachdem die <strong>EDUCATION</strong>-Lizenz aktiviert ist.</label>
              </div>
              <div class="col-md-9" if={parent.data.status == 3 && parent.data.isValidLicence}>
                  <label>Die MDM-Server Konfiguration kann erfolgen. Bitte klicken Sie auf 'Konfigurieren', um den Prozess zu starten.</label>
                </div>
                <div class="col-md-3" if={parent.data.status == 3 && parent.data.isValidLicence}>
                  <button class="btn btn-primary" onclick="{parent.configure}">Konfigurieren</button>
                </div>
                <div class="col-md-12" if={parent.data.status == 4}>
                  <label>Der MDM-Server wird konfiguriert. Bitte warten Sie, bis der MDM-Server fertig konfiguriert ist.</label>
              </div>

              <div class="col-md-12" if={parent.data.status == 5}>
                <div class="p-2 border border-success">
                    <span><paedml-icon icon="fas-check-circle" simple="success" />
                        <strong class="text-success pl-1 pt-2">Der MDM-Server wurde konfiguriert.</strong>
                    </span>
                </div>
              </div>
            </div>
          </div>

          <div class="paedml-input-group" if={parent.data.status != 5}>
            <div class="pb-1">
            Status
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="p-2 border border-success" if={parent.data.isMdmOnline}>
                  <span><paedml-icon icon="fas-check-circle" simple="success" />
                    Der MDM-Server ist <strong class="text-success pl-1 pt-2">online.</strong>
                  </span>
                </div>
                <div class="p-2 border border-danger" if={!parent.data.isMdmOnline}>
                  <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                    Der MDM-Server ist <strong class="text-danger pl-1 pt-2">offline.</strong>
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary" onclick="{parent.refreshStatus}">Status aktualisieren</button>
              </div>
            </div>
          </div>

          <div class="row" if={parent.data.status != 5}>
              <div class="col-md-12">
                <div class="mt-2 mr-1 p-2 border border-info">
                  <span><paedml-icon icon="fas-info-circle" simple="info" />
                      <strong class="text-info pl-1 pt-2">Update des MDM-Servers kann bis zu 5 Minuten dauern.</strong>
                  </span>
                  </div>
              </div>
          </div>

          <div class="row" if={parent.data.status != 5}>
            <div class="m-2 p-2">
              <span class="pl-1 pt-2">Es werden Jobs erstellt, um den MDM-Server zu aktualisieren.</span>
              <p></p>
              <paedml-form-input name="redirect" placeholder="Nach der Ausführung zur 'JobQueue'-Ansicht springen" fgclass="py-1"
                type="checkbox" revlut="jaNein"
                />
            </div>
          </div>
        </div>

      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      import API from '../../api'
      
      this.heading = this.opts.heading

      this.data = {
            isMdmOnline: false,
            status: 0,
            licenseModelName: "UNBEKANNT",
            settingsOk: false,
            databaseOk: false,
            storageOk: false,
        }

    this.refreshStatus = (e) => {
      e.preventDefault()
      e.stopPropagation()
       this.getStatus();
    }

    this.getStatus = () => {
      this.loading = true
        API.mdm.status().then(rsp => {
          const [data, status] = rsp
          this.loading = false
          this.data = data
          
          this.data.isValidLicence = data.licenseModelName ? data.licenseModelName.toLowerCase().includes('education') : false
          
          this.update()

          $('input[name=database]', this.root).val(this.data.database)
          $('input[name=requiredDatabase]', this.root).val(this.data.requiredDatabase)
          $('input[name=storage]', this.root).val(this.data.storage)
          $('input[name=requiredStorage]', this.root).val(this.data.requiredStorage)
        })
      }

    this.isVersionOk = () => {
        return this.data.databaseOk && this.data.storageOk
    }

    this.init = (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.data.status = 2
      this.update()

      API.mdm.init().then(rsp => {
        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        this.parent.trigger('reloadTable')
        return Promise.resolve('MDM Initialisierung gestartet')
      })
    }

    this.configure = (e) => {

      e.preventDefault()
      e.stopPropagation()

      this.data.status = 4
      this.update()

      API.mdm.configure().then(rsp => {
        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        this.parent.trigger('reloadTable')
        return Promise.resolve('MDM API Initialisierung gestartet')
      })
    }

    this.on('dataRequested', () => {
        this.getStatus()
    })

    this.submitHandler = formData => {
        
        if (this.data.redirect)  setTimeout(() => { 
            $('body').removeClass('modal-open')
            window.location.href = '/#jobverwaltung/jobs' 
          }, 500)

          this.parent.trigger('reloadTable')
          return Promise.resolve('OK')
    }
    </script>
</paedml-modal-config-mdm>
